module.exports = __webpack_public_path__ + "static/img/图层 538.efe61aca.png";